module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c(_vm.currentView, {
    tag: "component"
  }), _vm._v(" "), _c('menu', {
    staticClass: "tab tab-menu"
  }, [_c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.currentViewName == 'Home'
    },
    on: {
      "click": function($event) {
        return _vm.activateView('Home')
      }
    }
  }, [_c('nav', {
    staticClass: "icon icon-home"
  }), _vm._v(" "), _c('nav', {
    staticClass: "f-small"
  }, [_vm._v("诊疗服务")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.currentViewName == 'OutMap'
    },
    on: {
      "click": function($event) {
        return _vm.activateView('OutMap')
      }
    }
  }, [_c('nav', {
    staticClass: "icon icon-msg"
  }), _vm._v(" "), _c('nav', {
    staticClass: "f-small"
  }, [_vm._v("来院导航")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.currentViewName == 'Profile'
    },
    on: {
      "click": function($event) {
        return _vm.activateView('Profile')
      }
    }
  }, [_c('nav', {
    staticClass: "icon icon-me"
  }), _vm._v(" "), _c('nav', {
    staticClass: "f-small"
  }, [_vm._v("个人中心")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14a53c0f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/index/Index.vue
// module id = 789
// module chunks = 0